import httpClient from "../http/http-client";
import { IPostRule, IRule, IRulePreview } from './rule.model';

// The rule forms carry conversionId as '' when no factor is chosen, but the backend
// spreads the body straight into a UUID column, where '' is a Postgres error.
// Exported so LibraryRuleService reuses it -- the library rules endpoint is fed by the same
// dialog and has exactly the same problem.
export const sanitizeRulePayload = (rule: IPostRule): IPostRule => ({
  ...rule,
  conversionId: rule.conversionId || null,
});

export default class RuleService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(query?: string): Promise<IRule[]> {
    return this.http.get(`rule${query ? `?${query}` : ''}`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getAllWithPagination(page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc', nameIncludes?: string, type?: string, includeImpact?: boolean): Promise<{ count: number, rows: IRule[] }> {
    const params = new URLSearchParams({ page: String(page), perPage: String(perPage) });
    if (order && orderBy) { params.append('orderBy', orderBy); params.append('order', order); }
    if (nameIncludes) params.append('nameIncludes', nameIncludes);
    if (type) params.append('type', type);
    if (includeImpact) params.append('includeImpact', 'true');
    return this.http.get(`rule?${params.toString()}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  // The factor the rule in the dialog would apply today (saved or not), with a worked example.
  async preview(rule: IPostRule): Promise<IRulePreview> {
    return this.http.post(`rule/preview`, sanitizeRulePayload(rule))
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getOne(ruleId: string): Promise<IRule> {
    return this.http.get(`rule/${ruleId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async create(rule: IPostRule): Promise<IRule> {
    return this.http.post(`rule`, sanitizeRulePayload(rule))
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async edit(ruleId: string, rule: IPostRule): Promise<IRule> {
    return this.http.patch(`rule/${ruleId}`, sanitizeRulePayload(rule))
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async delete(ruleId: string): Promise<IRule> {
    return this.http.delete(`rule/${ruleId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}